module.exports = __webpack_public_path__ + "img/ES.542814c7.webp";